export default __webpack_public_path__ + "8802f20785d089aeae59b46c771adb10.webp";